import { Injectable } from '@angular/core';
import { EventNeo } from '@fichaje/interfaces/ficha.interface';

@Injectable({
  providedIn: 'root'
})
export class EventNeoEmptyService {
  public readonly event:EventNeo = {
      // EVENT IDS
      id:                    0,
      schedule_rule_id:      0,
      schedule_rule_line_id: 0,
      company_id:            0,
      company_short_name:    '',

      // EVENT TYPE
      type:             '',
      is_flexible:      false,
      type_of_flexible: '',
      show_estimate:    false,
      is_night_shift:   false,
      event_start_adjusted_by_management:  false,
      event_adjusted_by_request:       false,
      is_overtime:      false,

      // EVENT START
      event_start_clock_in:   null,
      event_start_expected:   null,
      event_start_tolerance:  0,
      event_start_control:    0,
      event_start_limit:      0, //! pendiente, minutos

      // EVENT END
      event_end_clock_out:  null,
      event_end_expected:   null,
      event_end_tolerance:  0,
      event_end_control:    0, //! por ahora control y tolerancia de salida son iguales
      event_end_limit:      0,

      // EVENT WORKING HOURS
      working_hours_penalty:   0,
      working_hours_tolerance: 0,
      working_hours_clocked:   0,
      working_hours_expected:  0,

      working_hours_expected_overtime:  0, //! deberia fusionarse con expected
      working_hours_expected_default:   0, //! deberia fusionarse con expected

      // EVENT LOCATION
          //    event start
      event_start_location_prone_name: null,
      event_start_location_map_img:    null,
      event_start_location_longitud:   null,
      event_start_location_latitud:    null,
      event_start_location_bio_name:   null,
          //    event end
      event_end_location_prone_name:   null,
      event_end_location_map_img:      null,
      event_end_location_longitude:    null,
      event_end_location_latitude:     null,
      event_end_location_bio_name:     null,

      // SUB EVENTS
      lunch:        null,
      pauses_limit: null,

      // SUMMARY ELEMENTS
      attachments:          0,
      img_number:           0,
      pdfs_number:          0,
      signature_img:        null,
      remote_work:          false,

      // EVENT CLIENT ASSIGN
      client_assign_name: null,
      client_assign_id:   null,

      // EVENT END
      instructions_by_management:   null,

      incidence_code: 0,

      incidence_clock_in_id:       null,
      incidence_clock_in_reason:   null,
      incidence_clock_in_comment:  null,

      incidence_clock_out_id:      null,
      incidence_clock_out_reason:  null,
      incidence_clock_out_comment: null,

      incidence_working_hours_id:      null,
      incidence_working_hours_reason:  null,
      incidence_working_hours_comment: null,

    }

}
